import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/zh-cn";
export default {
  name: "electronicInvoice",
  components: {
    DatePicker: DatePicker,
    electronicInvoiceDetails: function electronicInvoiceDetails() {
      return import('./electronicInvoice-details/electronicInvoice-details');
    }
  },
  data: function data() {
    return {
      act_tab: 0,
      search_val: "",
      time: null,
      startTime: "",
      endTime: "",
      r_icon: "https://obs.pujian.com/frontend/app/user/r_suc.png",
      total: 0,
      current: 1,
      // 页码
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      isShowRuler: false,
      isShowDetails: false,
      infoList: [],
      detailData: {}
    };
  },
  created: function created() {
    this.getInvoiceList();
    if (this.$route.query.orderNumber) {
      this.toDeatils(this.$route.query);
    }
  },
  methods: {
    //切换Tab
    checkTab: function checkTab(val) {
      this.current = 1;
      this.act_tab = val;
      this.r_icon = val === 0 ? "https://obs.pujian.com/frontend/app/user/r_suc.png" : "https://obs.pujian.com/frontend/app/user/r_wait.png";
      this.getInvoiceList();
    },
    clearIconClick: function clearIconClick() {
      this.current = 1;
      this.search_val = "";
      this.getInvoiceList();
    },
    //返回发票中心
    backInvoice: function backInvoice(flag) {
      this.isShowDetails = false;
    },
    //设置选择今天以及今天之前的日期
    disabledDate: function disabledDate(time) {
      return time.getTime() > Date.now() - 8.64e6;
    },
    // 日期下拉框
    handleSelect: function handleSelect(val) {
      this.current = 1;
      this.startTime = this.formatDate(val[0]);
      this.endTime = this.formatDate(val[1]);
      console.log(this.startTime, this.endTime);
      this.getInvoiceList();
    },
    //清空时间
    handleClear: function handleClear() {
      this.current = 1;
      this.startTime = "";
      this.endTime = "";
      this.getInvoiceList();
    },
    //日期格式化
    formatDate: function formatDate(value) {
      var date = new Date(value);
      var y = date.getFullYear();
      var MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "/" + MM + "/" + d;
    },
    //分页
    handleChange: function handleChange(val) {
      this.current = val;
      this.getInvoiceList();
    },
    toDeatils: function toDeatils(item) {
      this.getInvoiceDetail(item.orderNumber);
    },
    //获取发票详情
    getInvoiceDetail: function getInvoiceDetail(orderNumber) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$getHttpClient().get("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/orderInvoiceDetail?orderNumber=" + orderNumber);
            case 2:
              res = _context.sent;
              if (res.data.code == 200) {
                _this.detailData = res.data.data;
                _this.isShowDetails = true;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //获取发票列表
    getInvoiceList: function getInvoiceList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.$getHttpClient().post("/pjyy-deepexi-order-center/api/v1/order/OcOrderEInvoice/orderInvoiceList", {
                invoiceStatus: _this2.act_tab + 1,
                orderNumber: _this2.search_val,
                page: _this2.current,
                pageSize: _this2.perPage,
                startTime: _this2.startTime,
                endTime: _this2.endTime
              });
            case 2:
              res = _context2.sent;
              if (res.data.code == 200) {
                _this2.infoList = res.data.data.content;
                _this2.total = res.data.data.totalElements;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};